export default __webpack_public_path__ + "static/media/index.cd97a7b5.less";